import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "slot-before d-flex align-items-center justify-content-center" }
const _hoisted_2 = ["id", "readonly", "type", "value", "placeholder"]
const _hoisted_3 = { class: "slot-after d-flex align-items-center justify-content-center" }

import { reactive } from 'vue'

  // Components
  import InputWrapper from './InputWrapper.vue'
  import InputFieldError from './InputFieldError.vue'

  interface Props {
    id?: string
    value: string
    label?: string
    readOnly?: boolean
    placeholder?: string
    upperInscriptionBackground?: string
    inputStyles?: { [key: string]: string }
    containerBoxBorder?: string
    containerBorderRadius?: string
    inputType?: string
    focused?: boolean
    error?: string
    showError?: boolean
    class?: string
    wrapperClass?: string
    allowedType?: 'number' | 'text'
    inputEvents?: Record<string, any>
  }
  interface Emits {
    (e: 'change', value: string): void
    (e: 'input', value: string): void
    (e: 'blur'): void
    (e: 'click'): void
  }

  // state
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Input',
  props: {
    id: {},
    value: { default: '' },
    label: {},
    readOnly: { type: Boolean },
    placeholder: {},
    upperInscriptionBackground: {},
    inputStyles: {},
    containerBoxBorder: {},
    containerBorderRadius: {},
    inputType: {},
    focused: { type: Boolean },
    error: {},
    showError: { type: Boolean },
    class: { default: 'py-2' },
    wrapperClass: {},
    allowedType: {},
    inputEvents: {}
  },
  emits: ["change", "input", "blur", "click"],
  setup(__props: any, { emit: __emit }) {

  const state = reactive({
    isFocused: false,
  })

  // props
  const props = __props

  // emit
  const emit = __emit

  // handlers
  // handlers
  const handleInput = (e: Event) => {
    if (props.readOnly) return
    const inputElement = e.target as HTMLInputElement
    let inputValue = inputElement.value

    // Conditionally filter input based on allowedType
    if (props.allowedType === 'number') {
      // Replace non-numeric characters to enforce numeric input
      inputValue = inputValue.replace(/\D/g, '')
      inputElement.value = inputValue // Set the sanitized value back to the input
    }

    emit('input', inputValue)
  }

  const handleChange = (e: Event) => {
    if (props.readOnly) return
    const inputElement = e.target as HTMLInputElement
    const inputValue = inputElement.value
    emit('change', inputValue)
  }
  const handleFocus = (e: Event) => {
    if (props.readOnly) return
    state.isFocused = true
  }
  const handleBlur = (e: Event) => {
    state.isFocused = false
  }

  const handleClick = (): void => {
    emit('click')
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.class)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["position-relative main-wrapper", `${props.readOnly && 'disabled'} ${props.wrapperClass || ''}`])
    }, [
      _createVNode(InputWrapper, {
        ref: "input-container",
        border: _ctx.containerBoxBorder,
        borderRadius: _ctx.containerBorderRadius,
        class: "container-wrapper",
        active: state.isFocused || props.focused,
        error: _ctx.showError ? props.error : ''
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "before")
          ]),
          _renderSlot(_ctx.$slots, "input", {}, () => [
            _createElementVNode("input", _mergeProps({
              id: props.id,
              readonly: props.readOnly,
              ref: "input"
            }, _toHandlers(_ctx.inputEvents, true), {
              onInput: _cache[0] || (_cache[0] = e => handleInput(e)),
              onChange: _cache[1] || (_cache[1] = e => handleChange(e)),
              onFocus: _cache[2] || (_cache[2] = e => handleFocus(e)),
              onBlur: _cache[3] || (_cache[3] = e => handleBlur(e)),
              onClick: handleClick,
              class: ["main-input form-control shadow-none no-autofill border-transparent tf-input", _ctx.showError && _ctx.error && 'error'],
              type: props.inputType ?? 'text',
              value: props.value,
              placeholder: state.isFocused ? '' : props.placeholder,
              style: props.inputStyles
            }), null, 16, _hoisted_2)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "after")
          ])
        ]),
        _: 3
      }, 8, ["border", "borderRadius", "active", "error"]),
      (state.isFocused || props.value)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            class: "upper-inscription bg-primary-white text-blue-800",
            style: _normalizeStyle({ background: props.upperInscriptionBackground })
          }, _toDisplayString(props.label), 5))
        : _createCommentVNode("", true),
      (_ctx.showError)
        ? (_openBlock(), _createBlock(InputFieldError, {
            key: 1,
            text: _ctx.error
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})